import { defineMessages } from 'react-intl'

export default defineMessages({
  accountHeading: {
    id: 'accountSettings.accountSection.heading',
    defaultMessage: 'Account',
  },
  emailLabel: {
    id: 'accountSettings.accountSection.emailLabel',
    defaultMessage: 'Your email address',
  },
})
